import { useState } from 'react';
import { CheckCircle2, Circle, AlertCircle, ChevronDown, ChevronRight } from 'lucide-react';
import { buildSetupChecklistItems } from './commercantSetupChecklistItems';

export { buildSetupChecklistItems };

/**
 * Checklist configuration boutique (super admin / gérant) — ligne compacte + détail dépliable.
 */
export default function CommercantSetupChecklist({
  commercant,
  accountStatus,
  produitsCount = 0,
  prestationsCount = 0,
  zonesCount = 0,
  isSuperAdmin = false,
  onNavigateItem,
}) {
  const [expanded, setExpanded] = useState(false);

  if (!commercant) return null;

  const items = buildSetupChecklistItems({
    commercant,
    accountStatus,
    produitsCount,
    prestationsCount,
    zonesCount,
    isSuperAdmin,
  });

  const done = items.filter((i) => i.ok).length;
  const total = items.length;
  const allOk = done === total;
  const countLabel = `${done}/${total} complété${done > 1 ? 's' : ''}`;

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-gray-100/80 rounded-lg transition-colors"
        aria-expanded={expanded}
      >
        <span className="flex items-center gap-2 min-w-0">
          {expanded ? (
            <ChevronDown className="h-4 w-4 text-gray-500 flex-shrink-0" />
          ) : (
            <ChevronRight className="h-4 w-4 text-gray-500 flex-shrink-0" />
          )}
          {allOk ? (
            <CheckCircle2 className="h-5 w-5 text-green-600 flex-shrink-0" />
          ) : (
            <AlertCircle className="h-5 w-5 text-amber-600 flex-shrink-0" />
          )}
          <span className="text-md font-semibold text-gray-900 truncate">
            Configuration boutique —{' '}
            <span className={allOk ? 'text-green-700' : 'text-amber-700'}>{countLabel}</span>
          </span>
        </span>
      </button>

      {expanded && (
        <ul className="space-y-2 px-4 pb-4 pt-0 border-t border-gray-200/80">
          {items.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => onNavigateItem?.(item)}
                className="w-full flex items-start gap-2 text-left text-sm rounded-md px-2 py-1.5 hover:bg-white transition-colors"
              >
                {item.ok ? (
                  <CheckCircle2 className="h-4 w-4 text-green-600 flex-shrink-0 mt-0.5" />
                ) : (
                  <Circle className="h-4 w-4 text-gray-400 flex-shrink-0 mt-0.5" />
                )}
                <span className={item.ok ? 'text-gray-700' : 'text-gray-900 font-medium'}>
                  {item.label}
                  {item.hint && (
                    <span className="block text-xs text-amber-700 font-normal">{item.hint}</span>
                  )}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
